import { render, staticRenderFns } from "./Faucet.vue?vue&type=template&id=cfd4a900&scoped=true&"
import script from "./Faucet.vue?vue&type=script&lang=ts&"
export * from "./Faucet.vue?vue&type=script&lang=ts&"
import style0 from "./Faucet.vue?vue&type=style&index=0&id=cfd4a900&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd4a900",
  null
  
)

export default component.exports